import React from 'react';
import classnames from 'classnames';
import SvgIcon from '@home/components/SvgIcon';

import type { IBaseProps, ITag } from '@intelligence/components/GenreSelect/types';

import '@intelligence/components/GenreSelect/components/Tag/index.scss';

export type ITagDeleteHandler = (value: string, data?: ITag['data']) => void;

export interface ITagProps extends IBaseProps, ITag {
  onDelete?: ITagDeleteHandler;
}

const Tag: React.FC<ITagProps> = (props) => {
  const { style, className, label, value, data, onDelete } = props;

  return (
    <span style={style} className={classnames('intelligence-tag', className)}>
      <span className="intelligence-tag-value">{label}</span>
      <span
        className="intelligence-tag-close"
        onClick={(e) => {
          e.stopPropagation();
          onDelete?.(value, data);
        }}
      >
        <SvgIcon type="clonse" />
      </span>
    </span>
  );
};

export default Tag;
